import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { motion } from "framer-motion";
import { ASSETS } from "../lib/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const subscribeErrorMessage = (status) => {
  if (status === 409) return "You're already on the list.";
  if (status === 422) return "Enter a valid email address.";
  return "Something went wrong. Try again.";
};

export const CoffeeClub = ({ onOpenClub }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setLoading(true);
    try {
      await axios.post(`${API}/subscribe`, { email, source: "newsletter" });
      toast.success("You're in. Watch your inbox for gremlin mischief.");
      setEmail("");
    } catch (err) {
      toast.error(subscribeErrorMessage(err?.response?.status));
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer data-testid="footer-section" className="relative pt-24 md:pt-32 border-t border-white/10">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10">
        {/* newsletter */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 pb-20">
          <div>
            <p className="font-mono text-xs uppercase tracking-[0.3em] text-ember mb-4">Join the Coffee Club</p>
            <h2 className="font-display font-black uppercase tracking-tight text-cream text-4xl md:text-6xl leading-[0.9]">
              Get first dibs<br /><span className="font-serif italic font-normal lowercase text-ember">& free shipping</span>
            </h2>
            <p className="font-mono text-sm text-cream/75 mt-5 max-w-md leading-relaxed">
              Early flavor drops, subscriber-only pricing and merch before anyone else.
            </p>
            <button
              onClick={onOpenClub}
              data-testid="footer-club-button"
              className="mt-7 inline-flex font-mono text-xs uppercase tracking-widest bg-ember text-void px-6 py-3.5 rounded-full font-medium hover:bg-emberDark transition-colors duration-200"
            >
              Reserve a Subscription →
            </button>
          </div>

          <form onSubmit={submit} data-testid="newsletter-form" className="self-end w-full">
            <label className="font-mono text-[11px] uppercase tracking-widest text-cream/65">Newsletter</label>
            <div className="flex items-center gap-4 border-b-2 border-cream/30 focus-within:border-ember transition-colors mt-3 pb-3">
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@email.com"
                data-testid="newsletter-email-input"
                className="flex-1 bg-transparent font-mono text-lg text-cream placeholder:text-cream/30 outline-none"
              />
              <button
                type="submit"
                disabled={loading}
                data-testid="newsletter-submit-button"
                className="font-mono text-xs uppercase tracking-widest text-ember hover:text-cream transition-colors disabled:opacity-50"
              >
                {loading ? "..." : "Sign up"}
              </button>
            </div>
          </form>
        </div>

        {/* giant wordmark */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          className="flex items-center justify-center gap-6 py-6"
        >
          <img src={ASSETS.mascot} alt="" className="w-16 h-16 md:w-24 md:h-24 rounded-full object-cover ring-2 ring-ember" />
          <span className="font-display font-black uppercase tracking-tight text-cream text-[15vw] leading-none select-none">
            Gremlin
          </span>
        </motion.div>

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 py-10 border-t border-white/10 font-mono text-[11px] uppercase tracking-widest text-cream/55">
          <span>© {new Date().getFullYear()} Gremlin Coffee · Air Roasted in Nashville, TN</span>
          <div className="flex gap-6">
            <span>Air Roasted</span><span>Small Batch</span><span>Nashville</span>
          </div>
          <span>Ships across North America</span>
        </div>
      </div>
    </footer>
  );
};
